import React from "react";
import { Dialog, DialogContent, Avatar } from "@mui/material";
import IFeedback from "../../models/Feedback";

type PropTypes = {
  viewDetails: boolean;
  handleCloseDetails: () => void;
  selectedFeedback: IFeedback;
};

const ViewFeedbackModal = ({ viewDetails, handleCloseDetails, selectedFeedback }: PropTypes) => {
  return (
    <Dialog open={viewDetails} onClose={handleCloseDetails} maxWidth="sm" fullWidth>
      <DialogContent>
        <Avatar alt="User Avatar" sx={{ width: "100%", height: "auto", borderRadius: 1 }} />
      </DialogContent>
    </Dialog>
  );
};

export default ViewFeedbackModal;
